import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import QRCodeStyling from "qr-code-styling";
import routes from "./api/routes";
import orderRoutes from "../order/api/routes";
import BrandedLoading from "../common/BrandedLoading";
import SectionPaper from "../common/SectionPaper";
import EmptyMessage from "../common/EmptyMessage";
import { messageShow } from "../common/api/actions";
import {
  Tooltip,
  Box,
  Button,
  Toolbar,
  Typography,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Modal,
  Grid
} from "@mui/material";

import {
  Search,
  Add,
  QrCode,
  FilterList,
  Edit,
  Refresh,
  Delete,
  Link as LinkIcon,
  Close,
  Download,
  LightbulbOutlined as LightbulbOutlinedIcon,
  ChevronRight as ChevronRightIcon,
  PlayCircleOutline as PlayCircleOutlineIcon,
} from "@mui/icons-material";
import { getQrTable } from "./api/query";
import { toggleQrTableStatus, deleteQrTable } from "./api/mutation";
import { settingDetail } from "../setting/api/actions/query";
import { checkPermission } from "../common/Sidebar/checkPermission";
import "./style.css";

const QRTable = () => {
  const dispatch = useDispatch();
  const [qrTables, setQrTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [copiedId, setCopiedId] = useState(null);
  const [qrLoading, setQrLoading] = useState(false);
  const [modalCopied, setModalCopied] = useState(false);
  const qrRef = useRef(null);
  const [qrCode, setQrCode] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState(null);
  const [qrDiningAppUrl, setqrDiningAppUrl] = useState(null);
  const [permissions, setPermissions] = useState({canView:false, canEdit:false, canDelete:false, canCreate:false})
  
  const fetchPermissions = async () => {
    const userPermissions = await checkPermission("store","qrDining");
    setPermissions(userPermissions);
  };
      
  const fetchData = async () => {
    try {
      const res = await getQrTable();
      if (res.success && Array.isArray(res.data)) {
        setQrTables(res.data);
      } else {
        setQrTables([]);
      }
    } catch (error) {
      console.error("Failed to fetch QR Tables:", error);
    } finally {
      setLoading(false);
    }
  };

   const fetchSettings = async () => {
    try {
      const res = await dispatch(settingDetail());
      const currencySymbol= res?.data?.data.currencyData.symbol;
      setCurrencySymbol(currencySymbol);
      const url = res?.data?.data?.qrDiningAppUrl || "";
      setqrDiningAppUrl(url);
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  };  

  useEffect(() => {
    fetchData();
    fetchSettings()
    fetchPermissions();
  }, []);

  const filteredTables = qrTables.filter((table) => {
    if (filter === "Active" && table.isActive && !table.isOccupied) return true;
    if (filter === "Occupied" && table.isOccupied) return true;
    if (filter === "All") return true;
    return false;
  }).filter((table) => {
  const query = searchQuery.toLowerCase();
  const matchesTableName = table.tableName?.toLowerCase().includes(query);
  const matchesEmail = table.tableUserId?.email?.toLowerCase().includes(query);
  return matchesTableName || matchesEmail;
  });

  const handleCopy = (id, url) => {
    navigator.clipboard.writeText(url);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  const handleToggleStatus = async (id, currentStatus) => {
    const action = currentStatus ? "deactivate" : "activate";

    if (!window.confirm(`Are you sure you want to ${action} this table?`)) {
      return;
    }
    try {
      const res = await toggleQrTableStatus(id, !currentStatus);
      if (res.success) {
        await fetchData();
        dispatch(messageShow(`Table ${action}d successfully`));
      }
    } catch (err) {
      console.error("Error toggling status:", err);
      dispatch(messageShow("Error updating table status"));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this QR Table?"))
      return;

    try {
      const res = await deleteQrTable(id);
      if (res.success) {
        await fetchData();
        dispatch(messageShow(`Table deleted successfully`));
      }
    } catch (err) {
      console.error("error deleting QR Table:", err);
      dispatch(messageShow(`Error deleting table`));
    }
  };

  const handleOpen = (row) => {
    setSelectedRow(row);
    setQrLoading(true);
    setOpen(true);
     const qr = new QRCodeStyling({
    width: 256,
    height: 256,
    type: "png",
    data: row.loginUrl,
    image: "", // optional logo
    dotsOptions: { color: "#000", type: "rounded" },
    backgroundOptions: { color: "#fff" },
  });

  setQrCode(qr);
  };
 
useEffect(() => {
  if (qrCode && qrRef.current) {
    qrCode.append(qrRef.current);
    setQrLoading(false);
  }
}, [qrCode]);

const handleDownload = (ext) => {
  if (qrCode) {
    qrCode.download({ extension: ext, name: selectedRow?.tableName || "qr-code" });
  }
};


  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const renderHelper = () => (
    <Box sx={{ p: 2, pt: 2 }}>
      <Box 
        sx={{ 
          backgroundColor: '#F8F9FE', 
          borderRadius: '8px', 
          border: '1px solid #E9ECEF',
          p: 3
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} sx={{ color: '#5E72E4' }}>
          <Box display="flex" alignItems="center">
            <LightbulbOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
              QR DINING QUICK TIPS
            </Typography>
          </Box>
          <Button 
            href="https://youtu.be/oCHHQ9c_N6Y?si=4GlqbsOjSS-BuzCe" 
            target="_blank" 
            size="small" 
            startIcon={<PlayCircleOutlineIcon />}
            sx={{ 
              color: '#5E72E4', 
              fontWeight: 600, 
              textTransform: 'none',
              '&:hover': { backgroundColor: 'rgba(94, 114, 228, 0.08)' }
            }}
          >
            Watch Demo Video
          </Button>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="flex-start">
              <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                <span style={{ fontWeight: 600, color: '#32325D' }}>Table Management:</span> Create and manage QR tables for different locations. Each table has a unique QR code.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="flex-start">
              <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                <span style={{ fontWeight: 600, color: '#32325D' }}>QR Codes:</span> Download QR codes in various formats. Print and place them on tables for customer ordering.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="flex-start">
              <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                <span style={{ fontWeight: 600, color: '#32325D' }}>Order Tracking:</span> When a customer scans and orders, the Order ID will appear and link directly to details.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="flex-start">
              <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                <span style={{ fontWeight: 600, color: '#32325D' }}>Staff Login:</span> Use the staff login from the mobile app to track and edit table orders in real-time.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );

  return (
    <div>
      <Toolbar className="toolbar">
        <Typography variant="h6" className="grow">
          QR Dining
        </Typography>
        <Tooltip title="Add Table" arrow>
        <Link
          to={{
            pathname: routes.createorUpdate.path,
            state: { qrDiningAppUrl }
          }}
        >
          <Button
            startIcon={<Add />}
            // className="addTableBtn"
            color="primary"
            size='big' 
            disabled={!permissions?.canCreate}
          ></Button>
        </Link>
        </Tooltip>
      </Toolbar>

      <Box className="qrTableWrapper">
        {qrTables.length > 0 && !loading && (
          <Box className="filterBar">
            <TextField
              variant="outlined"
              placeholder="Search table name or email"
              size="small"
              className="searchInput"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <Close
                      onClick={() => setSearchQuery("")}
                      style={{ cursor: "pointer", fontSize: "18px" }}
                    />
                  </InputAdornment>
                ),
              }}
            />
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                <FilterList
                  fontSize="small"
                  sx={{ mr: 0.5, color: "text.secondary" }}
                />
                <Typography variant="body2" color="text.secondary">
                  Status
                </Typography>
              </Box>
              <Select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                size="small"
                className="statusFilter"
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Occupied">Occupied</MenuItem>
              </Select>
            </Box>
          </Box>
        )}
        {loading ? (
          <BrandedLoading />
        ) : qrTables.length === 0 ? (
          <SectionPaper>
            <EmptyMessage message={"No tables found."} />
          </SectionPaper>
        ) : (
          <TableContainer component={Paper} className="tableContainer">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "10%" }}>Order ID</TableCell>
                  <TableCell sx={{ width: "15%" }}>Table Name</TableCell>
                  <TableCell sx={{ width: "20%" }}>Table User</TableCell>
                  <TableCell sx={{ width: "10%" }}>QR Token</TableCell>
                  <TableCell sx={{ width: "10%" }}>Login URL</TableCell>
                  <TableCell sx={{ width: "10%" }}>Status</TableCell>
                  <TableCell sx={{ width: "30%" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredTables.length > 0 ? (
                  filteredTables.map((qrTable) => (
                    <TableRow key={qrTable._id}>
                      <TableCell>
                      {qrTable.orderId?.id ? (
                        <Link
                          to={{
                            pathname: orderRoutes.orderDetail.path(qrTable.orderId._id),
                            state: { 
                              order: qrTable.orderId, 
                              currencySymbol
                            }
                          }}
                        >
                        <Typography
                          component="span"
                          sx={{
                            fontWeight: 500,
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {qrTable?.orderId?.id.toUpperCase()}
                        </Typography>
                        </Link>
                      ) : (
                        "-"
                      )}
                      </TableCell>
                      <TableCell>{qrTable.tableName}</TableCell>
                      <TableCell>{qrTable.tableUserId?.email}</TableCell>
                      <TableCell>{qrTable.qrToken}</TableCell>
                      <TableCell>
                        <Button
                          variant="outlined"
                          startIcon={<LinkIcon />}
                          size="small"
                          className="actionBtn"
                          disabled={!permissions?.canView}
                          onClick={() =>
                            handleCopy(qrTable._id, qrTable.loginUrl)
                          }
                        >
                          {copiedId === qrTable._id ? "Copied!" : "Copy"}
                        </Button>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={
                            qrTable.isOccupied ? "Occupied" : "Active"
                          }
                          className={
                            qrTable.isOccupied ? "statusChipOccupied" : "statusChipActive"
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <Box className="actionGroup">
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<QrCode />}
                            className="actionBtn"
                            onClick={() => handleOpen(qrTable)}
                            disabled={!permissions?.canView}
                          >
                            QR
                          </Button>
                          <Link
                            to={{
                              pathname: routes.createorUpdate.path,
                              state: { tableId: qrTable._id }, 
                            }}
                          >
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<Edit />}
                              className="actionBtn"
                              disabled={!permissions?.canEdit}
                            >
                              Edit
                            </Button>
                          </Link>
                          {/* <Button
                            variant="outlined"
                            size="small"
                            startIcon={<Refresh />}
                            className="actionBtn"
                          >
                            Token
                          </Button> */}
                          {/* <Button
                            variant="outlined"
                            size="small"
                            className="actionBtn"
                            disabled={!permissions?.canEdit}
                            onClick={() =>
                              handleToggleStatus(qrTable._id, qrTable.isActive)
                            }
                          >
                            {qrTable.isActive ? "Deactivate" : "Activate"}
                          </Button> */}
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<Delete />}
                            className="deleteBtn"
                            onClick={() => handleDelete(qrTable._id)}
                            disabled={!permissions?.canDelete}
                          >
                            Delete
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      align="center"
                      style={{ padding: "20px" }}
                    >
                      No tables found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            width: 600,
            p: 3,
          }}
        >
          {selectedRow && (
            <>
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <Typography variant="h6">
                  QR Code — {selectedRow.tableName}
                </Typography>
                <Button onClick={handleClose} sx={{ minWidth: "auto" }}>
                  <Close sx={{ color: "#000" }} />
                </Button>
              </Box>

              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                URL
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    wordBreak: "break-all",
                    flex: 1,
                    mr: 2,
                  }}
                >
                  {selectedRow.loginUrl}
                </Typography>
                <Button
                  variant="outlined"
                  startIcon={<LinkIcon />}
                  disabled={!permissions?.canView}
                  sx={{
                    borderRadius: "50px",
                    textTransform: "none",
                    fontWeight: 500,
                    color: "#0f172a",
                    borderColor: "#c2c2c2ff",
                    px: 2.5,
                    "&:hover": {
                      borderColor: "#D8DCE1",
                      backgroundColor: "#f8fafc",
                    },
                  }}
                  onClick={() =>{
                    navigator.clipboard.writeText(selectedRow.loginUrl)
                    setModalCopied(true);
                    setTimeout(() => setModalCopied(false), 2000);
                  }}
                >
                  {modalCopied ? "Copied!" : "Copy URL"}
                </Button>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "12px",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fff",
                  p: 4,
                  mb: 2,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                }}
              >
                {qrLoading && <BrandedLoading />}
                {/* <div ref={qrRef} style={{ display: qrLoading ? "none" : "block" }} /> */}
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=150}x150&data=${encodeURIComponent(
                    selectedRow.loginUrl
                  )}`}
                  alt="QR Code"
                  width={256}
                  height={256}
                  style={{
                    borderRadius: "6px",
                    display: qrLoading ? "none" : "block", 
                  }}
                  onLoad={() => setQrLoading(false)}
                />
              </Box>
              
              {!qrLoading && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  mt: 2,
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<Download />}
                  sx={{
                    borderRadius: "50px",
                    textTransform: "none",
                    fontWeight: 500,
                    color: "#0f172a",
                    borderColor: "#c2c2c2ff",
                    px: 2.5,
                    "&:hover": {
                      borderColor: "#D8DCE1",
                      backgroundColor: "#f8fafc",
                    },
                  }}
                    onClick={() => handleDownload("png")}
                >
                  Download PNG
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<Download />}
                  sx={{
                    borderRadius: "50px",
                    textTransform: "none",
                    fontWeight: 500,
                    color: "#0f172a",
                    borderColor: "#c2c2c2ff",
                    px: 2.5,
                    "&:hover": {
                      borderColor: "#D8DCE1",
                      backgroundColor: "#f8fafc",
                    },
                  }}
                   onClick={() => handleDownload("svg")}
                >
                  Download SVG
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<Download />}
                  sx={{
                    borderRadius: "50px",
                    textTransform: "none",
                    fontWeight: 500,
                    color: "#0f172a",
                    borderColor: "#c2c2c2ff",
                    px: 2.5,
                    "&:hover": {
                      borderColor: "#cbd5e1",
                      backgroundColor: "#f8fafc",
                    },
                  }}
                  onClick={() => handleDownload("jpeg")}
                >
                  Download JPEG
                </Button>
              </Box>
              )}
            </>
          )}
        </Box>
      </Modal>
      {!loading && renderHelper()}
    </div>
  );
};

export default QRTable;
